import { render, staticRenderFns } from "./ArtworkProductsDialog.vue?vue&type=template&id=d347a02c&scoped=true"
import script from "./ArtworkProductsDialog.vue?vue&type=script&lang=js"
export * from "./ArtworkProductsDialog.vue?vue&type=script&lang=js"
import style0 from "./ArtworkProductsDialog.vue?vue&type=style&index=0&id=d347a02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d347a02c",
  null
  
)

export default component.exports